{
  "shared": {
    "approved": "Approved",
    "pending": "Pending",
    "pendingApproval": "Pending approval",
    "rejected": "Rejected",
    "active": "Active",
    "inactive": "Inactive",
    "activate": "Activate",
    "deactivate": "Deactivate",
    "markInactive": "Mark inactive",
    "markVerified": "Mark verified",
    "toggleUbo": "Toggle UBO",
    "idVerified": "ID verified",
    "idUnverified": "ID unverified",
    "ubo": "UBO: {{status}}",
    "docMeta": "{{format}} · uploaded {{date}} ·",
    "roleModerator": "Moderator",
    "roleSuperModerator": "Super moderator",
    "superOnly": "Super-moderator only.",
    "restricted": "Restricted area.",
    "deleteModeratorConfirm": "Delete moderator {{name}}? This cannot be undone.",
    "fullName": "Full name",
    "phone": "Phone",
    "optionalPlaceholder": "optional",
    "updateError": "Update failed."
  },
  "dashboard": {
    "welcome": "Welcome back, {{name}}",
    "subtitleSuper": "Super-moderator overview.",
    "subtitle": "Moderator overview — your queue and platform metrics.",
    "loadError": "Failed to load dashboard metrics.",
    "platformMetrics": "Platform metrics",
    "totalCompanies": "Total companies",
    "companiesMeta": "{{verified}} verified · {{pending}} pending · {{flagged}} flagged",
    "conversionRate": "Conversion rate",
    "vsLastMonth": "{{value}} vs last month",
    "dealVolume": "Deal volume",
    "avgResponseTime": "Avg. response time",
    "companyBreakdown": "Company breakdown",
    "verified": "Verified",
    "pendingApproval": "Pending approval",
    "flagged": "Flagged"
  },
  "companies": {
    "title": "Companies",
    "subtitle": "Browse all companies, filter by tag, and update tags assigned to each.",
    "searchPlaceholder": "Search by name or email",
    "allTags": "All tags",
    "allRegions": "All regions",
    "allCountries": "All countries",
    "filterBySourceType": "Filter by source type",
    "allSourceTypes": "All source types",
    "filterByNamedSource": "Filter by named source",
    "allNamedSources": "All named sources",
    "inactiveSource": "{{name}} (inactive)",
    "notListed": "Not listed (free text)",
    "reset": "Reset",
    "loading": "Loading companies…",
    "loadError": "Failed to load companies.",
    "empty": "No companies match.",
    "compliance": "Compliance: {{status}} ({{score}})",
    "badge": "Badge: {{label}}",
    "source": "Source: {{label}}",
    "tagsLabel": "Tags:",
    "noTags": "No tags configured. Add tags via Django admin.",
    "open": "Open",
    "editTags": "Edit tags"
  },
  "companyDetail": {
    "invalidId": "Invalid company id.",
    "loadError": "Failed to load company.",
    "superOnlyHint": "Approve, flag and reactivate: super moderator only.",
    "approving": "Approving…",
    "approveCompany": "Approve company",
    "flagging": "Flagging…",
    "flagDeactivate": "Flag (deactivate)",
    "reactivate": "Reactivate",
    "flagConfirmTitle": "Flag {{name}}?",
    "flagConfirmBody": "They will lose access until reactivated.",
    "notifyPartners": "Notify partners with open deals or conversations that {{name}} is no longer available (no reason is shared)",
    "confirmFlag": "Confirm flag",
    "flagError": "Could not flag this company.",
    "approveError": "Could not approve this company.",
    "badgeTooltip": "The public badge a moderator awarded (it claims only what its evidence covers). Open KYB to run checks or award a badge.",
    "openKyb": "Open KYB",
    "industryChip": "Industry: {{value}}",
    "countryChip": "Country: {{value}}",
    "regionChip": "Region: {{value}}",
    "sourceTooltip": "Where the company heard about MatchPoint (moderators only)",
    "primaryMarketChip": "Primary market: {{value}}",
    "tradeProfile": "Trade profile",
    "tradeProfileIncomplete": "Incomplete — this company is left out of corridor matching until it is filled in.",
    "info": {
      "title": "Company info",
      "name": "Name",
      "nameRequired": "Name is required (max 255 chars).",
      "industry": "Industry",
      "country": "Country",
      "selectCountry": "— Select country —",
      "region": "Region",
      "selectRegion": "— Select region —",
      "primaryMarket": "Primary market (free text)",
      "save": "Save company info"
    },
    "compliance": {
      "title": "Compliance",
      "overallStatus": "Overall status",
      "verified": "Verified",
      "notVerified": "Not verified",
      "overallScore": "Overall score (0–100)",
      "tier1": "Tier 1 — basic verification",
      "tier2": "Tier 2 — standard compliance",
      "tier3": "Tier 3 — advanced due diligence",
      "save": "Save compliance"
    },
    "tags": {
      "title": "Tags",
      "empty": "No tags configured. Create some via Django admin.",
      "save": "Save tags"
    },
    "documents": {
      "title": "Documents ({{count}})",
      "empty": "No documents uploaded yet."
    },
    "registrations": {
      "title": "Entity registrations ({{count}})",
      "empty": "No registrations submitted."
    },
    "shareholders": {
      "title": "Shareholders ({{count}})",
      "empty": "No shareholders submitted."
    }
  },
  "verification": {
    "title": "Verification queue",
    "subtitle": "Review pending documents, entity registrations, and shareholder IDs across every company.",
    "tabs": {
      "documents": "Documents",
      "registrations": "Registrations",
      "shareholders": "Shareholders"
    },
    "documentsLoadError": "Failed to load documents.",
    "loadError": "Failed to load.",
    "empty": "Nothing to review.",
    "unverified": "Unverified",
    "verified": "Verified"
  },
  "moderators": {
    "title": "Moderators",
    "subtitle": "Manage who has moderator access.",
    "add": "Add moderator",
    "createError": "Create failed.",
    "searchPlaceholder": "Search by name, email, or id",
    "loadError": "Failed to load moderators.",
    "empty": "No moderators.",
    "initialPassword": "Initial password (≥ 8 chars)",
    "phoneOptional": "Phone (optional)",
    "creating": "Creating…"
  },
  "moderatorDetail": {
    "invalidId": "Invalid moderator id.",
    "loadError": "Failed to load moderator.",
    "selfHint": "You cannot deactivate or delete your own account.",
    "editProfile": "Edit profile",
    "saved": "Saved.",
    "role": "Role",
    "resetPassword": "Reset password (min. 8 characters, leave blank to keep current)"
  },
  "profile": {
    "updated": "Profile updated.",
    "loadError": "Failed to load profile.",
    "title": "My profile",
    "subtitle": "Update your name, phone, and password. Role and status are managed by a super moderator.",
    "identity": "Identity",
    "save": "Save profile",
    "twoFactor": {
      "title": "Two-factor authentication",
      "setupError": "Failed to start 2FA setup.",
      "invalidCode": "Invalid code.",
      "invalidPasswordOrCode": "Invalid password or code.",
      "enabled": "Enabled",
      "disabled": "Disabled",
      "intro": "Add a second step at sign-in. You'll scan a QR code with an authenticator app and confirm a 6-digit code.",
      "regenerate": "Regenerate recovery codes",
      "disable": "Disable 2FA",
      "enable": "Enable 2FA",
      "preparing": "Preparing…",
      "qrAlt": "2FA QR code",
      "manualKey": "Or enter this key manually: <code>{{secret}}</code>",
      "sixDigitCode": "6-digit code",
      "enabling": "Enabling…",
      "saveCodes": "<strong>Save these recovery codes now.</strong> They are shown only once and let you sign in if you lose your authenticator.",
      "copy": "Copy",
      "downloadTxt": "Download .txt",
      "savedThem": "I saved them",
      "disableIntro": "Disabling 2FA needs both your password and a current 6-digit code.",
      "password": "Password",
      "authCode": "Authentication code",
      "disabling": "Disabling…",
      "regenerateIntro": "This invalidates every previously-issued recovery code. Confirm with a current 6-digit code.",
      "generating": "Generating…",
      "generateCodes": "Generate codes"
    },
    "password": {
      "changeError": "Could not change password.",
      "tooShort": "New password must be at least 8 characters.",
      "mismatch": "New password and confirmation do not match.",
      "title": "Change password",
      "current": "Current password",
      "new": "New password",
      "confirm": "Confirm new password",
      "changing": "Changing…",
      "updated": "Password updated."
    }
  },
  "leadSources": {
    "types": {
      "institution": "Institution",
      "event": "Event",
      "partner": "Partner"
    },
    "addError": "Could not add the source.",
    "saveError": "Could not save the source.",
    "deleteError": "Could not delete the source.",
    "nameRequired": "Please enter a name.",
    "deleteConfirm": "Delete \"{{name}}\"?",
    "title": "Lead sources",
    "subtitle": "Institutions, events and partners companies can pick when they register (\"How did you hear about us?\"). Inactive sources are hidden from registration but stay on the companies that chose them.",
    "sourceName": "Source name",
    "sourceType": "Source type",
    "add": "Add source",
    "superOnly": "Only super moderators can change this list.",
    "loading": "Loading sources…",
    "loadError": "Failed to load sources.",
    "empty": "No named sources yet. Companies can still describe their source in free text.",
    "table": {
      "type": "Type",
      "companies": "Companies",
      "relationship": "Relationship"
    },
    "inUse": "In use — deactivate instead",
    "relationship": {
      "label": "Commercial relationship",
      "help": "Paid partners trigger a disclosure line on counterparty-facing match surfaces.",
      "free_referral": "Free referral",
      "paid_referral": "Paid referral",
      "revenue_share": "Revenue share",
      "other": "Other"
    },
    "commission": {
      "label": "Commission (%)",
      "help": "Required for paid referral and revenue share. Internal — never shown to counterparties."
    },
    "disclosure": {
      "label": "Counterparty disclosure",
      "help": "Shown verbatim to the other company whenever a company sourced via this partner appears on a match surface. Do not name the partner — the disclosure must not reveal partner identity."
    }
  },
  "productFeedback": {
    "unverified": {
      "title": "Unverified HS codes",
      "subtitle": "Accepted, but not in the official HS table — no HS credit in matching until corrected.",
      "loadError": "Failed to load unverified HS codes.",
      "chip": "Unverified HS code"
    },
    "title": "Product feedback",
    "subtitle": "Review user-submitted HS code corrections and approve or reject them.",
    "loading": "Loading feedback…",
    "loadError": "Failed to load feedback.",
    "empty": "No feedback in this state.",
    "feedbackId": "Feedback #{{id}}",
    "from": "From {{email}} ({{company}}) · {{date}}",
    "noCompany": "no company",
    "reported": "Reported: <strong>{{product}}</strong> / HS <strong>{{hsCode}}</strong>",
    "userNote": "User note: {{message}}",
    "approvedCorrection": "Approved correction: <strong>{{product}}</strong> / HS <strong>{{hsCode}}</strong>",
    "approveWithCorrection": "Approve with correction",
    "correctedName": "Corrected product name",
    "correctedHs": "Corrected HS code",
    "rejecting": "Rejecting…",
    "moderatorComment": "Moderator comment",
    "commentPlaceholder": "Internal note for other moderators…",
    "saveComment": "Save comment",
    "review": "Review"
  },
  "articles": {
    "categories": {
      "REGULATION": "Regulation",
      "GEOPOLITICS": "Geopolitics",
      "BUSINESS_NEWS": "Business News"
    },
    "allCategories": "All categories",
    "titleRequired": "Title is required.",
    "saveError": "Save failed. Check the fields and try again.",
    "title": "Articles",
    "subtitle": "Create and target news / regulatory articles. Leave companies empty to broadcast to everyone.",
    "new": "New article",
    "edit": "Edit article",
    "searchPlaceholder": "Search title or source",
    "loading": "Loading articles…",
    "loadError": "Failed to load articles.",
    "empty": "No articles.",
    "broadcast": "Broadcast",
    "targeted": "Targeted",
    "sourceMeta": "Source: {{source}}",
    "released": "Released: {{date}}",
    "originalLink": "Original link",
    "pdf": "PDF",
    "form": {
      "title": "Title",
      "category": "Category",
      "releaseDate": "Release date",
      "brief": "Brief",
      "source": "Source",
      "pdf": "PDF report (optional)",
      "pdfHint": "{{hint}}. Stored privately. Replaces any existing PDF on save.",
      "targetCompanies": "Target companies — leave empty to broadcast"
    },
    "deleteTitle": "Delete article?",
    "deleteBody": "This action cannot be undone."
  },
  "analytics": {
    "title": "Funnel analytics",
    "subtitle": "Match-funnel conversion, tiered success and moderator time — read-only.",
    "loadError": "Failed to load analytics.",
    "filters": {
      "from": "From",
      "to": "To",
      "corridor": "Corridor",
      "source": "Lead source",
      "allCorridors": "All corridors",
      "allSources": "All sources",
      "apply": "Apply filters"
    },
    "sources": {
      "institution": "Institution",
      "event": "Event",
      "partner": "Partner",
      "other": "Other",
      "unknown": "Unknown"
    },
    "funnel": {
      "title": "Match funnel",
      "subtitle": "Matched deals only. Manual deals are reported separately.",
      "matched": "Matched",
      "accepted": "Accepted (supplier consent)",
      "inProgress": "In progress (any stage date)",
      "won": "Won",
      "fromMatched": "{{value}}% of matched",
      "fromPrev": "{{value}}% from previous step",
      "exitsTitle": "Exits",
      "exitsDeclined": "Declined by supplier",
      "exitsLost": "Lost deals",
      "noData": "No deals in this range."
    },
    "tiered": {
      "title": "Tiered success (D1-7)",
      "earlyLabel": "First meeting within {{days}} days of acceptance",
      "mainLabel": "Signed / won within {{days}} days of acceptance",
      "numerator": "{{num}} of {{denom}}",
      "cohortNote": "Only deals accepted long enough ago for the window to have elapsed are counted.",
      "noCohort": "Cohort is empty."
    },
    "cycleTimes": {
      "title": "Cycle times (days)",
      "matchToAccept": "Match → Accepted",
      "acceptToFirstMeeting": "Accepted → First meeting",
      "acceptToWon": "Accepted → Won",
      "median": "Median",
      "p75": "p75",
      "count": "n = {{n}}"
    },
    "moderatorHours": {
      "title": "Moderator time (DealTimeLog)",
      "subtitle": "Minutes logged on deals in this range. Cap: {{cap}} min per deal (D1-6).",
      "deals": "Deals with time logged",
      "total": "Total minutes",
      "avg": "Avg min / deal",
      "median": "Median min / deal",
      "bucketsTitle": "Per-deal distribution vs cap",
      "bucketLe30": "≤ 30 min",
      "bucketLe60": "31–60 min",
      "bucketLe120": "61–120 min",
      "bucketGt120": "> 120 min",
      "perModeratorTitle": "Per moderator",
      "name": "Moderator",
      "minutes": "Minutes",
      "dealsCount": "Deals",
      "removedModerator": "Removed moderator",
      "empty": "No time logged in this range."
    },
    "manualDeals": {
      "title": "Manual deals (WP1.7)",
      "subtitle": "Excluded from the match funnel. Shown separately for transparency.",
      "count": "Total",
      "won": "Won",
      "lost": "Lost",
      "open": "Open"
    }
  },
  "readiness": {
    "pageTitle": "Export Readiness",
    "pageSubtitle": "Manage the readiness questions companies answer before launching match requests. Super moderators can create, edit and delete questions; moderators have read access.",
    "activeCount": "{{active}} active · {{total}} total",
    "bands": {
      "ready": "Ready",
      "developing": "Developing",
      "not_ready": "Not ready",
      "none": "Not taken"
    },
    "passed": "Passed",
    "notPassed": "Not passed",
    "columns": {
      "key": "Key",
      "text": "Question",
      "weight": "Weight",
      "options": "Options",
      "active": "Active",
      "actions": "Actions"
    },
    "actions": {
      "new": "New question",
      "edit": "Edit",
      "delete": "Delete",
      "addOption": "Add option"
    },
    "form": {
      "editTitle": "Edit question",
      "newTitle": "New question",
      "key": "Key (slug)",
      "keyHint": "Short machine identifier (letters, numbers, dashes). Used in exports.",
      "text": "Question text",
      "helpText": "Help text (optional)",
      "improvementTip": "Improvement tip (shown when the company doesn't pick the top answer)",
      "weight": "Weight (1–100)",
      "order": "Display order",
      "isActive": "Active (counts for scoring)",
      "options": "Answer options",
      "optionText": "Option text",
      "optionPoints": "Points (0–100)",
      "optionOrder": "Order",
      "needTwoOptions": "A question needs at least two options.",
      "save": "Save",
      "saving": "Saving…",
      "cancel": "Cancel"
    },
    "deleteTitle": "Delete this question?",
    "deleteBody": "Historical assessments keep their snapshot of the question text — the question is removed from future scoring only.",
    "readOnly": "Read only · ask a super moderator to make changes.",
    "errors": {
      "load": "Couldn't load readiness questions.",
      "save": "Couldn't save the question.",
      "delete": "Couldn't delete the question."
    },
    "companies": {
      "pageTitle": "Companies — readiness",
      "filterLabel": "Filter by band",
      "all": "All",
      "none": "Not taken",
      "columns": {
        "company": "Company",
        "score": "Score",
        "band": "Band",
        "status": "Status",
        "takenAt": "Taken"
      },
      "empty": "No companies match this filter."
    },
    "dashboard": {
      "title": "Readiness",
      "activatedCompanies": "Activated companies",
      "activatedHint": "Approved + trade profile + readiness passed",
      "withoutAssessment": "No assessment",
      "activeQuestions": "Active questions",
      "viewAll": "View readiness →"
    },
    "companyPanel": {
      "title": "Export readiness",
      "noAssessment": "This company hasn't taken the check yet.",
      "takenAt": "Taken {{date}}",
      "score": "Score {{score}} / 100",
      "band": "Band {{band}}"
    }
  },
  "billing": {
    "title": "Billing",
    "subtitle": "Plans, credit packs and success fees. Prices, limits and pack sizes are set here.",
    "superOnly": "Only super moderators can change plans, packs and credits.",
    "saveError": "Couldn't save. Please try again.",
    "codeNameRequired": "Code and name are required.",
    "loading": "Loading...",
    "loadError": "Failed to load billing data.",
    "unlimited": "Unlimited",
    "yes": "Yes",
    "no": "No",
    "fields": {
      "code": "Code",
      "name": "Name",
      "requestLimit": "Requests / month",
      "matchLimit": "Matches / month",
      "dealLimit": "Active deals",
      "feePercent": "Success fee %",
      "stripePrice": "Stripe price ID",
      "stripePriceIds": "Per-currency Stripe price IDs",
      "stripePriceIdsPlaceholder": "One per line, e.g. CAD=price_...\\nUSD=price_...\\nAED=price_...",
      "currencies": "Currencies",
      "usesCredits": "Uses credits",
      "credits": "Credits"
    },
    "plans": {
      "title": "Plans",
      "hint": "Limits are per calendar month; leave blank for unlimited. Companies without a plan use the plan coded \"pilot\", or are unmetered if there is none.",
      "add": "Add plan",
      "empty": "No plans yet. Every company is on the free, unmetered pilot."
    },
    "packs": {
      "title": "Credit packs",
      "hint": "One-off purchases; 1 credit = 1 match request. A pack is on sale when it is active and has a Stripe price ID that is allowed on this environment.",
      "add": "Add pack",
      "empty": "No credit packs yet.",
      "creditsInvalid": "Credits must be a whole number of at least 1."
    },
    "fees": {
      "title": "Success fees",
      "hint": "Recorded when a deal is marked won and attributed to MatchPoint with a deal value. Nothing is charged.",
      "empty": "No success fees recorded yet.",
      "deal": "Deal",
      "buyer": "Buyer",
      "supplier": "Supplier",
      "wonAt": "Won",
      "dealValue": "Deal value",
      "amount": "Fee",
      "noRate": "No rate set",
      "dealLink": "Deal #{{id}}",
      "status": {
        "pending": "Pending",
        "void": "Void"
      }
    },
    "company": {
      "title": "Plan & credits",
      "adjustError": "Couldn't adjust the credits.",
      "creditsInvalid": "Enter a whole, non-zero number of credits (negative to remove).",
      "reasonRequired": "A reason is required.",
      "plan": "Plan",
      "defaultPlan": "Default plan",
      "assignPlan": "Assign plan",
      "credits": "Credits",
      "reason": "Reason",
      "adjust": "Adjust credits",
      "ledger": "Credit ledger",
      "ledgerEmpty": "No credit movements yet.",
      "when": "When",
      "kind": "Type",
      "by": "By",
      "kinds": {
        "purchase": "Purchase",
        "usage": "Match request",
        "refund": "Refund (failed run)",
        "adjustment": "Adjustment"
      }
    }
  },
  "hsClassifier": {
    "title": "HS classifier",
    "subtitle": "How products get their HS codes: local sources vote, the result stops where they disagree, and moderators' corrections become precedents.",
    "playground": {
      "title": "Try it",
      "help": "Runs the same classifier companies use, and shows how each source voted. Runs you start here appear in the log.",
      "run": "Classify",
      "fields": {
        "name": "Product name",
        "material": "Material (optional)",
        "use": "Use (optional)",
        "description": "Description (optional)"
      }
    },
    "runs": {
      "help": "Every classification, with its inputs, votes and result. Correct a wrong one, or confirm a right one: both become precedents for similar products.",
      "loadError": "Could not load classifier runs.",
      "empty": "No runs here.",
      "filter": {
        "uncorrected": "To review",
        "corrected": "Corrected / confirmed",
        "all": "All"
      },
      "status": {
        "classified": "Classified",
        "needs_answer": "Asked a question",
        "unclassifiable": "No code"
      },
      "source": {
        "classify": "Product form",
        "suggest": "Suggest",
        "matching": "Match request"
      },
      "duration": "{{ms}} ms",
      "within": "within {{code}}",
      "result": "Result {{code}} ({{depth}}, confidence {{confidence}})",
      "chosen": "requester used {{code}}",
      "confirmed": "Confirmed",
      "corrected": "Corrected to {{code}}",
      "by": " by {{name}}",
      "details": "Votes & correct",
      "hide": "Hide",
      "correctHelp": "The right code for this product. It must exist in the HS table.",
      "code": "HS code",
      "note": "Note (optional)",
      "confirm": "Confirm {{code}}",
      "saveCorrection": "Save correction",
      "correctError": "Could not save the correction."
    }
  }
}
